"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var EMPTY_MAP = _immutable.default.Map();

var initialMoreAppsState = new _immutable.default.Map({
  hasCategoryResults: false,
  results: new _immutable.default.OrderedSet()
});

var initialState = _immutable.default.fromJS({
  listingViewsCache: EMPTY_MAP,
  listingViewsFetchErrorCache: EMPTY_MAP,
  listingViewsFetchStatusCache: EMPTY_MAP,
  moreApps: initialMoreAppsState
});

var details = function details() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case ActionTypes.DETAILS_FETCH_REQUESTED:
      {
        var slug = meta.slug;
        return state.withMutations(function (mutableState) {
          return mutableState.setIn(['listingViewsFetchStatusCache', slug], RequestState.PENDING).deleteIn(['listingViewsFetchErrorCache', slug]);
        });
      }

    case ActionTypes.DETAILS_FETCH_RECEIVED:
      {
        var _slug = meta.slug;
        return state.withMutations(function (mutableState) {
          return mutableState.setIn(['listingViewsCache', _slug], payload).setIn(['listingViewsFetchStatusCache', _slug], RequestState.SUCCEEDED);
        });
      }

    case ActionTypes.DETAILS_FETCH_FAILED:
      {
        var _slug2 = meta.slug;
        return state.withMutations(function (mutableState) {
          return mutableState.setIn(['listingViewsFetchErrorCache', _slug2], payload).setIn(['listingViewsFetchStatusCache', _slug2], RequestState.FAILED);
        });
      }

    case ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED:
      return state.set('moreApps', payload);

    case ActionTypes.DETAILS_MORE_APPS_RESET:
      return state.set('moreApps', initialMoreAppsState);

    default:
      return state;
  }
};

var _default = details;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/details.js
// module id = 638
// module chunks = 209 210 211 212